<template>
  <ProductTabList :list="features">
    <template #after>
      <li
        v-if="documentUrls.length"
        class="product-tab-list__entry"
        data-testid="product-tab-list-downloads"
      >
        <strong class="product-tab-list__label">
          <template v-if="hasManyDocuments">Bedienungsanleitungen</template>
          <template v-else>Bedienungsanleitung</template>
        </strong>
        <ul class="product-tab-list__value list">
          <li
            v-for="(documentUrl, index) in documentUrls"
            :key="index"
          >
            <a
              :href="documentUrl"
              target="_blank"
              rel="noopener"
              data-tealium-rel="content.text.download"
              class="link"
            >
              Download
              <span v-if="documentUrls.length > 1">({{ index + 1 }})</span>
            </a>
          </li>
        </ul>
      </li>
    </template>
  </ProductTabList>
</template>

<script setup lang="ts">
import ProductTabList from '~/components/product-detail/tabs/product-tab-list.vue';
import type { Feature } from '~/components/product-detail/tabs/feature-list.vue';

type Document = NonNullable<Offer['documents']>[number];

const goliathImagePath = '/public';
const productImagePath = '/product-images';

const GOLIATH_PATH_PREFIX_REGEXP = RegExp(`^${goliathImagePath}`);

const replacePathPrefix = (path: string) =>
  path?.replace(GOLIATH_PATH_PREFIX_REGEXP, productImagePath);

const attachmentUrl = (attachment: Document) => {
  if (!attachment) return undefined;
  if (attachment.remote && 'url' in attachment) return attachment.url;
  if ('path' in attachment && attachment.path) return replacePathPrefix(attachment.path);
  return undefined;
};

export type TechnicalDetailsProps = {
  features: Feature[];
  documents?: Document[];
};

const props = withDefaults(defineProps<TechnicalDetailsProps>(), {
  documents: () => [],
});

const documentUrls = computed(() => props.documents.map(attachmentUrl).filter(Boolean));
const hasManyDocuments = computed(() => documentUrls.value.length > 1);
</script>
